import { render } from "./About.vue?vue&type=template&id=3d30b2f0&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=3d30b2f0&scoped=true&lang=scss"

import exportComponent from "D:\\work\\CodeV4\\FCP-Web-V4\\leanloop-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d30b2f0"]])

export default __exports__